import { OktaAuthOptions } from '@okta/okta-auth-js';

export interface OktaBootstrapConfig {
  enabled: boolean;
  client_id: string;
  issuer: string;
  login_path?: string;
}

interface BuiltOktaConfig {
  oidc: OktaAuthOptions;
  loginPath: string;
}

const isBrowser =
  typeof window !== 'undefined' && typeof window.location !== 'undefined';
const isTest =
  typeof process !== 'undefined' &&
  (process.env.NODE_ENV === 'test' ||
    Boolean(process.env.VITEST) ||
    Boolean(process.env.VITEST_WORKER_ID));

export function buildOktaConfig(
  bootstrap: OktaBootstrapConfig,
  originOverride?: string
): BuiltOktaConfig {
  const origin = (
    originOverride ||
    (isBrowser ? window.location.origin : process.env?.REACT_APP_BASE_URL) ||
    'http://localhost:3000'
  ).replace(/\/$/, '');

  return {
    oidc: {
      clientId: bootstrap.client_id,
      issuer: bootstrap.issuer,
      redirectUri: `${origin}/login`,
      postLogoutRedirectUri: `${origin}/login`,
      scopes: ['openid', 'profile', 'email'],
      pkce: true,
      responseType: ['code'],
      tokenManager: {
        storage: isTest ? 'memory' : isBrowser ? 'localStorage' : 'memory',
        autoRenew: true,
        expireEarlySeconds: 60,
      },
      cookies: {
        secure: process.env.NODE_ENV === 'production',
        sameSite: process.env.NODE_ENV === 'production' ? 'lax' : 'none',
      },
      ...(process.env.NODE_ENV === 'development' && { devMode: true }),
    },
    loginPath: bootstrap.login_path || '/login',
  };
}
